import { mergeMap, switchMap } from 'rxjs';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError, IClientApiDependencySegment } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { AdjustmentProfileAction } from '../adjustmentProfile.action';

export const createAdjustmentEpic: IEpic<{}, IClientApiDependencySegment> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(AdjustmentProfileAction.create.started),
  switchMap((params) => {
    const { reject } = params;

    return dependencies.api.createAdjustmentProfile(params).pipe(
      mergeMap((response) => {
        return [AdjustmentProfileAction.create.done({ params, result: { adjustmentId: response.id } })];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          AdjustmentProfileAction.create.failed({ params, error: null }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
